/**
 * REPORT-SCREENSHOT-RPS-TEAMS.WIDGET.TSX
 */
import DashboardRpsTeamsWidget from "./dashboard-rps-teams.widget"

interface OwnProps {
  isFullWidth?: boolean
  isReport?: boolean
}

function ReportScreenshotRpsTeamsWidget(props: OwnProps) {
  return (
    <div
      className="flex"
      style={{
        transform: "scale(0.65)",
        transformOrigin: "top left",
        pointerEvents: "none"
      }}>
      <DashboardRpsTeamsWidget isReport={props.isReport} />
    </div>
  )
}

export default ReportScreenshotRpsTeamsWidget
